<template>
  <aside :class="['sidebar', themeClass]">
    <!-- Logo SICECOM en la parte superior -->
    <div class="sidebar-logo-top">
      <div class="logo-container-top">
        <img src="/logo_b.png" alt="SICECOM" class="logo-image-top" />
      </div>
    </div>
    
    <nav>
      <ul class="nav flex-column">

        <!-- Dashboard Principal -->
        <li>
          <router-link to="/" class="nav-link">
            <i class="bi bi-speedometer2"></i> Dashboard
          </router-link>
        </li>

        <!-- Empresas -->
        <li class="nav-group">
          <div class="nav-header" @click="toggleMenu('empresas')" :class="{ 'active': expandedMenus.empresas }">
            <i class="bi bi-buildings"></i>
            <span>Empresas</span>
            <i class="bi bi-chevron-down toggle-icon" :class="{ 'rotated': expandedMenus.empresas }"></i>
          </div>
          <transition name="submenu">
            <ul v-show="expandedMenus.empresas" class="submenu">
              <li><router-link to="/empresas" class="nav-link submenu-link">
                <i class="bi bi-list"></i> Lista
              </router-link></li>
              <li><router-link to="/empresas/nueva" class="nav-link submenu-link">
                <i class="bi bi-plus-circle"></i> Nueva
              </router-link></li>
              <li><router-link to="/empresas/subdominios" class="nav-link submenu-link">
                <i class="bi bi-globe"></i> Subdominios
              </router-link></li>
              <li><router-link to="/empresas/usuarios" class="nav-link submenu-link">
                <i class="bi bi-people"></i> Usuarios
              </router-link></li>
            </ul>
          </transition>
        </li>


        <!-- Módulos -->
        <li class="nav-group">
          <div class="nav-header" @click="toggleMenu('modulos')" :class="{ 'active': expandedMenus.modulos }">
            <i class="bi bi-grid-3x3-gap"></i>
            <span>Módulos</span>
            <i class="bi bi-chevron-down toggle-icon" :class="{ 'rotated': expandedMenus.modulos }"></i>
          </div>
          <transition name="submenu">
            <ul v-show="expandedMenus.modulos" class="submenu">
              <li><router-link to="/modulos" class="nav-link submenu-link">
                <i class="bi bi-grid-3x3-gap"></i> Disponibles
              </router-link></li>
              <li><router-link to="/modulos/permisos" class="nav-link submenu-link">
                <i class="bi bi-key"></i> Permisos
              </router-link></li>
              <li><router-link to="/modulos/activacion" class="nav-link submenu-link">
                <i class="bi bi-toggles"></i> Activación
              </router-link></li>
            </ul>
          </transition>
        </li>

        <!-- Facturación -->
        <li class="nav-group">
          <div class="nav-header" @click="toggleMenu('facturacion')" :class="{ 'active': expandedMenus.facturacion }">
            <i class="bi bi-credit-card"></i>
            <span>Facturación</span>
            <i class="bi bi-chevron-down toggle-icon" :class="{ 'rotated': expandedMenus.facturacion }"></i>
          </div>
          <transition name="submenu">
            <ul v-show="expandedMenus.facturacion" class="submenu">
              <li><router-link to="/facturacion/suscripciones" class="nav-link submenu-link">
                <i class="bi bi-credit-card"></i> Suscripciones
              </router-link></li>
              <li><router-link to="/facturacion/pagos" class="nav-link submenu-link">
                <i class="bi bi-currency-dollar"></i> Pagos
              </router-link></li>
              <li><router-link to="/facturacion/planes" class="nav-link submenu-link">
                <i class="bi bi-layers"></i> Planes
              </router-link></li>
            </ul>
          </transition>
        </li>

        <!-- Reportes -->
        <li class="nav-group">
          <div class="nav-header" @click="toggleMenu('reportes')" :class="{ 'active': expandedMenus.reportes }">
            <i class="bi bi-bar-chart"></i>
            <span>Reportes</span>
            <i class="bi bi-chevron-down toggle-icon" :class="{ 'rotated': expandedMenus.reportes }"></i>
          </div>
          <transition name="submenu">
            <ul v-show="expandedMenus.reportes" class="submenu">
              <li><router-link to="/reportes/empresas" class="nav-link submenu-link">
                <i class="bi bi-bar-chart"></i> Estadísticas
              </router-link></li>
              <li><router-link to="/reportes/ingresos" class="nav-link submenu-link">
                <i class="bi bi-graph-up"></i> Ingresos
              </router-link></li>
              <li><router-link to="/reportes/uso" class="nav-link submenu-link">
                <i class="bi bi-activity"></i> Uso
              </router-link></li>
            </ul>
          </transition>
        </li>

        <!-- Configuración -->
        <li class="nav-group">
          <div class="nav-header" @click="toggleMenu('configuracion')" :class="{ 'active': expandedMenus.configuracion }">
            <i class="bi bi-gear"></i>
            <span>Configuración</span>
            <i class="bi bi-chevron-down toggle-icon" :class="{ 'rotated': expandedMenus.configuracion }"></i>
          </div>
          <transition name="submenu">
            <ul v-show="expandedMenus.configuracion" class="submenu">
              <li><router-link to="/configuraciones/usuarios" class="nav-link submenu-link">
                <i class="bi bi-people"></i> Usuarios
              </router-link></li>
              <li><router-link to="/configuraciones/parametros" class="nav-link submenu-link">
                <i class="bi bi-gear"></i> Parámetros
              </router-link></li>
              <li><router-link to="/configuraciones/sri" class="nav-link submenu-link">
                <i class="bi bi-file-earmark-text"></i> SRI
              </router-link></li>
            </ul>
          </transition>
        </li>

      </ul>
    </nav>
  </aside>
</template>

<script>
import themeManager from '@/store/theme'

export default {
  name: 'AdminSidebar',
  data() {
    return {
      expandedMenus: {
        empresas: false,
        proveedores: false,
        modulos: false,
        facturacion: false,
        reportes: false,
        configuracion: false
      }
    }
  },
  computed: {
    themeClass() {
      return themeManager.themeClass
    }
  },
  methods: {
    toggleMenu(menuKey) {
      this.expandedMenus[menuKey] = !this.expandedMenus[menuKey]
      // Cerrar otros menús para mantener solo uno abierto (opcional)
      // Object.keys(this.expandedMenus).forEach(key => {
      //   if (key !== menuKey) {
      //     this.expandedMenus[key] = false
      //   }
      // })
    },
    
    // Expandir automáticamente el menú que contiene la ruta actual
    expandActiveMenu() {
      const currentPath = this.$route.path
      
      if (currentPath.includes('/admin/empresas')) {
        this.expandedMenus.empresas = true
      } else if (currentPath.includes('/admin/proveedores')) {
        this.expandedMenus.proveedores = true
      } else if (currentPath.includes('/admin/modulos')) {
        this.expandedMenus.modulos = true
      } else if (currentPath.includes('/admin/facturacion')) {
        this.expandedMenus.facturacion = true
      } else if (currentPath.includes('/admin/reportes')) {
        this.expandedMenus.reportes = true
      } else if (currentPath.includes('/admin/configuracion')) {
        this.expandedMenus.configuracion = true
      }
    }
  },
  
  mounted() {
    // Expandir el menú correspondiente al cargar la página
    this.expandActiveMenu()
  },
  
  watch: {
    // Expandir el menú correspondiente al cambiar de ruta
    '$route'() {
      this.expandActiveMenu()
    }
  }
}
</script>

<style>
.sidebar {
  background: var(--sidebar-bg);
  padding: 1rem;
  height: 100vh;
  border-right: 1px solid var(--border-color);
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.nav-link {
  color: var(--text-secondary);
  display: block;
  padding: 0.5rem 0.75rem;
  text-decoration: none;
  border-radius: 0.375rem;
  margin-bottom: 0.25rem;
  transition: all 0.3s ease;
  position: relative;
}

.nav-link:hover {
  color: var(--text-primary);
  background-color: var(--sidebar-hover);
  transform: translateX(2px);
}

.nav-link.router-link-exact-active,
.nav-link.router-link-active {
  font-weight: 600;
  color: var(--primary-color);
  background-color: var(--sidebar-active);
  box-shadow: 0 2px 8px rgba(17, 115, 212, 0.15);
}

.nav-link i {
  width: 20px;
  margin-right: 0.5rem;
  text-align: center;
}

.nav-header {
  font-weight: 700;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  margin: 1.5rem 0 0.75rem 0;
  padding: 0 0.75rem;
  color: var(--text-muted);
  border-bottom: 1px solid var(--border-light);
  padding-bottom: 0.5rem;
}

/* Nested navigation styling */
li ul {
  list-style: none;
  padding-left: 0;
  margin-left: 1rem;
}

li ul .nav-link {
  font-size: 0.875rem;
  padding-left: 1.5rem;
}

/* Collapsible Menu Styles */
.nav-group {
  margin-bottom: 0.375rem;
}

.nav-header {
  display: flex;
  align-items: center;
  padding: 0.6rem 0.75rem;
  cursor: pointer;
  color: var(--text-primary);
  font-weight: 600;
  font-size: 0.875rem;
  border-radius: 0.5rem;
  transition: all 0.3s ease;
  background: var(--bg-tertiary);
  border: 1px solid var(--border-color);
  user-select: none;
  line-height: 1.2;
}

.nav-header:hover {
  background: var(--sidebar-hover);
  transform: translateY(-1px);
  box-shadow: var(--card-shadow);
}

.nav-header.active {
  background: var(--sidebar-active);
  color: var(--primary-color);
  box-shadow: var(--card-shadow);
}

.nav-header i:first-child {
  width: 18px;
  margin-right: 0.5rem;
  font-size: 1rem;
  flex-shrink: 0;
}

.nav-header span {
  flex: 1;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 0.875rem;
  font-weight: 600;
  margin-right: 0.5rem;
}

.toggle-icon {
  font-size: 0.75rem;
  transition: transform 0.3s ease;
  margin-left: 0.25rem;
  flex-shrink: 0;
}

.toggle-icon.rotated {
  transform: rotate(180deg);
}

/* Submenu Styles */
.submenu {
  list-style: none;
  padding: 0;
  margin: 0.5rem 0 0 0;
  background: var(--sidebar-hover);
  border-radius: 0.5rem;
  border: 1px solid var(--border-color);
  overflow: hidden;
}

.submenu-link {
  display: flex;
  align-items: center;
  padding: 0.5rem 0.875rem;
  color: var(--text-secondary);
  text-decoration: none;
  font-size: 0.8rem;
  transition: all 0.3s ease;
  border-bottom: 1px solid var(--border-color);
  line-height: 1.3;
}

.submenu-link:last-child {
  border-bottom: none;
}

.submenu-link:hover {
  background: var(--sidebar-active);
  color: var(--text-primary);
  padding-left: 1.125rem;
}

.submenu-link.router-link-active {
  background: var(--sidebar-active);
  color: var(--primary-color);
  font-weight: 600;
  border-left: 3px solid var(--primary-color);
}

.submenu-link i {
  width: 14px;
  margin-right: 0.5rem;
  font-size: 0.8rem;
  flex-shrink: 0;
}

/* Texto compacto para submenús */
.submenu-link {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.submenu-link span {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Submenu Transitions */
.submenu-enter-active,
.submenu-leave-active {
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: top;
}

.submenu-enter-from,
.submenu-leave-to {
  opacity: 0;
  transform: scaleY(0.8) translateY(-10px);
  max-height: 0;
}

.submenu-enter-to,
.submenu-leave-from {
  opacity: 1;
  transform: scaleY(1) translateY(0);
  max-height: 500px;
}

/* Logo Sidebar Top Styles */
.sidebar-logo-top {
  padding: 1rem 0.5rem;
  border-bottom: 1px solid var(--border-color);
  margin-bottom: 0.5rem;
  background: transparent;
  overflow: hidden;
}

.logo-container-top {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.logo-image-top {
  width: 240px;
  height: 85px;
  object-fit: contain;
  max-width: 98%;
  transition: transform 0.3s ease, filter 0.3s ease;
  filter: brightness(1.1) contrast(1.1);
}

.logo-image-top:hover {
  transform: scale(1.03);
  filter: brightness(1.2) contrast(1.2);
}



/* Scrollbar for sidebar */
.sidebar::-webkit-scrollbar {
  width: 4px;
}

.sidebar::-webkit-scrollbar-track {
  background: transparent;
}

.sidebar::-webkit-scrollbar-thumb {
  background: var(--border-color);
  border-radius: 2px;
}

.sidebar::-webkit-scrollbar-thumb:hover {
  background: var(--text-secondary);
}
</style>
